const gFormHlds = document.querySelectorAll('.gform_wrapper');
const sections = document.querySelectorAll('.gsection');
const tooltipsSections = document.querySelectorAll('.gfield:not(.gsection):not(.gfield--type-honeypot).gfield--has-description');

const formScripts = function(forms) {
	forms.forEach(form => {
		const formInputs = form.querySelectorAll('input[type="text"], input[type="text"], input[type="email"], input[type="number"], input[type="password"]');
		if (formInputs) {
			formInputs.forEach(item => {
				const parent = item.closest('.gfield');
				if (item.value !== '') {
					parent.classList.add('is-not-empty');
				} else {
					parent.classList.remove('is-not-empty');
				}
				item.addEventListener('input', () => {
					if (item.value !== '') {
						parent.classList.add('is-not-empty');
					} else {
						parent.classList.remove('is-not-empty');
					}
				});
			});
		}

		const formSelects = form.querySelectorAll('select');
		if (formSelects) {
			formSelects.forEach(item => {
				const parent = item.closest('.gfield');
				parent.classList.add('gfield--with-select');
				if (item.value !== '') {
					parent.classList.add('is-not-empty');
				} else {
					parent.classList.remove('is-not-empty');
				}
				item.addEventListener('change', () => {
					if (item.value !== '') {
						parent.classList.add('is-not-empty');
					} else {
						parent.classList.remove('is-not-empty');
					}
				});
			});
		}

		const formTextareas = form.querySelectorAll('textarea');
		if (formTextareas) {
			formTextareas.forEach(item => {
				const parent = item.closest('.gfield');
				parent.classList.add('gfield--with-textarea');
				if (item.value !== '') {
					parent.classList.add('is-not-empty');
				} else {
					parent.classList.remove('is-not-empty');
				}

				if (item.classList.contains('small')) {
					item.setAttribute('rows', '1');
					item.setAttribute('style', 'height:' + (item.scrollHeight) + 'px;');
					item.addEventListener('input', (event) => {
						if (item.value !== '') {
							parent.classList.add('is-not-empty');
						} else {
							parent.classList.remove('is-not-empty');
						}

						event.target.style.height = 'auto';
						event.target.style.height = (event.target.scrollHeight) + 'px';
						if (event.target.offsetHeight >= 185) {
							event.target.classList.add('is-scrollable');
						} else {
							event.target.classList.remove('is-scrollable');
						}
					});
				}
			});
		}

		form.classList.remove('is-loading');

		form.addEventListener('submit', () => {
			form.classList.add('is-loading');
		});

		const uploadsInput = form.querySelectorAll('input[type="file"]');
		if (uploadsInput) {
		    uploadsInput.forEach(item => {
				item.addEventListener('change', () => {
					if (item.files !== undefined) {
						const parent = item.closest('.gfield');
						if (parent) {
							parent.classList.add('is-file-uploaded');
							item.dataset.fileName = item.files[0].name;
						}
					}
				});
		    });
		}

		const checkboxStyle = form.querySelectorAll('.ginput_container_checkbox');
		if (checkboxStyle) {
		    checkboxStyle.forEach(item => {
		        const parent = item.closest('.gfield');
		        if (parent) {
		            parent.classList.add('is-checkboxes');
		        }
		    });
		}

		const radioStyle = form.querySelectorAll('.ginput_container_radio');
		if (radioStyle) {
		    radioStyle.forEach(item => {
		        const parent = item.closest('.gfield');
		        if (parent) {
		            parent.classList.add('is-radiobutton');
		        }
		    });
		}

		const formInfo = form.parentNode.querySelector('.js-form-info');
		if (formInfo) {
			const formFooter = form.querySelector('.gform_footer');
			const formInfoContent = form.querySelector('.js-form-info-content');
			if (!formInfoContent) {
				formFooter.innerHTML = `${formInfo.innerHTML} ${formFooter.innerHTML}`;
			}
		}
		sections.forEach(section => {
			const gsectionBreak = section.querySelector('.gsection_break');
			if (!gsectionBreak) {
				section.innerHTML = `<div class="gsection_break"><span></span></div>${section.innerHTML}`;
			}
		});
	});
};

if (gFormHlds) {
	/* eslint-disable */
    jQuery(document).on('gform_post_render', function(event, form_id) { // reinits form scripts each time form is rendered (ajax)
       formScripts(gFormHlds);
    });
    /* eslint-enable */
}

tooltipsSections.forEach(section => {
	const label = section.querySelector('.gfield_label');
	label.addEventListener('mouseover', () => {
		toggleTooltip(section);
	});
	label.addEventListener('mouseleave', () => {
		toggleTooltip(section);
	});
});

setTimeout(() => {
	setTootipPosition();
	document.addEventListener('resize', ()=>{
		setTootipPosition();
	});
}, 500);


function toggleTooltip(section) {
	const tooltips = section.querySelectorAll('.gfield_description');
	tooltips[tooltips.length - 1].classList.toggle('is-active');
}

function setTootipPosition() {
	tooltipsSections.forEach(section => {
		const label = section.querySelector('.gfield_label');
		const tooltips = section.querySelectorAll('.gfield_description');
		tooltips[tooltips.length - 1].style.left = label.offsetWidth - 30 + 'px';
	});
}
